<template>
  <div
    class="dashboard-page__info"
  >
    <a
      @click="getViewKpi"
      class="kleodora titanic--text mb-1 dashboard-page__link"
      v-hyphenate>
      {{ kpi.name || "Без названия" }}
    </a>
    <span
      :class="kpiStyle"
      class="titanic--text crephusa"
      v-hyphenate
    >{{ kpiData || 'данные не заполнены' }}</span>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { DateFormatted } from '@/plugins/DateFormatted'
export default {
  name: 'DashboardCard',
  props: {
    kpi: {
      type: Object
    }
  },
  computed: {
    kpiData () {
      if (this.kpi.maxChildrenCount > 0) {
        return  `${this.kpi.childrenCount}`
      }
      let val = this.kpi.value
      if (this.kpi.dataType === 'date') {
        val = (new DateFormatted(val)).ruFormat()
      }
      return val ? `${val} ${this.kpi.units || ''}` : null
    },
    kpiStyle () {
      if (this.kpi.maxChildrenCount === 0) {
        if (this.kpi.dataType !== 'string') {
          const min = this.kpi.minValue ? Number(this.kpi.minValue) : Number(this.kpi.value)
          const max = this.kpi.maxValue ? Number(this.kpi.maxValue) : Number(this.kpi.value)
          const val = Number(this.kpi.value)
          return val >= min && val <= max ? 'titanic--text' : 'fargo--text'
        }
        return [this.kpi.style === 'is-invalid' ? 'fargo--text' : 'titanic--text']
      }
      return {}
    }
  },
  methods: {
    ...mapActions('kpi', ['getKpiData']),
    getViewKpi () {
      this.getKpiData(this.kpi.id)
      .then(() => {
        this.$router.push({ name: 'DashboardCardEdit', params: { uuid: this.kpi.id }})
      })
    }
  }
}
</script>
